



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import Customer from "@/types/customer/Customer";
import getters from "@/store/modules/customer/getters";
import router from "@/router";
import Endpoint from "@/utils/endpoint";
import formatDate from "@/utils/formatDate";
import UserInterface from "@/types/app/IUser";
import Header from "@/types/app/header";
import CustomerAproovedHeader from "@/components/headers/customer-approved";
import ModalAccountGrouping from "@/views/customers/group.vue";
import moment from "moment";
import applyCondition from "@/utils/applyCondition";
import ModalCustomer from "@/views/customers/detail.vue";
import ModalAccountMirror from "./mirror.vue";
import ErrorService from "@/services/erroService";
import ModalCloneAccount from "@/views/accounts/clone.vue";
import ModalCacheManager from "@/components/common/ModalCacheManager.vue";
import BaseComponent from "@/utils/baseComponent";
import RefreshStore from "@/services/refreshStore";
import { dataSanitizeException } from "@microsoft/applicationinsights-common";
const namespace = "customer";

@Component({
  components: {
  },
  methods: {
    formatDate,
  },
})
export default class LesteManagers extends BaseComponent {
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Action("setLoading", { namespace }) setLoading!: any;
  private endpoint = new Endpoint();

  headers: Array<Header> = CustomerAproovedHeader.header;
  fullNameFilter = "";
  emailFilter = "";
  countryFilter = "";
  relationshipFilter = "";
  selectedCustomer: any[] = [];
  customers: Customer[] = []
  mounted() {
    this.getCustomers();
  }

  public getCustomers(): void {
    this.setLoading(true);
    this.$http
      .get(this.endpoint.lesteUser)
      .then((resp) => {
        if (resp.data) {
          this.customers = resp.data;
        }
        this.setLoading(false);
      })
      .catch((err) => {
        this.setLoading(false);
        ErrorService.onError(err);
      });
  }

  get filteredCustomers() {
    const conditions: any[] = [];
    if (this.fullNameFilter) {
      conditions.push((item: Customer) =>
        item.fullName.toLowerCase().includes(this.fullNameFilter.toLowerCase())
      );
    }

    if (this.emailFilter) {
      conditions.push((item: Customer) =>
        item.email.toLowerCase().includes(this.emailFilter.toLowerCase())
      );
    }

    if (this.countryFilter) {
      conditions.push((item: Customer) =>
        item.country.toLowerCase().includes(this.countryFilter.toLowerCase())
      );
    }

    if (this.relationshipFilter) {
      conditions.push((item: Customer) =>
        item.relationship
          .toString()
          .toLowerCase()
          .includes(this.relationshipFilter.toLowerCase())
      );
    }
    return applyCondition<Customer>(this.customers, conditions);
  }

  setModalCustomer(customerItem: Customer) {
    router.push({
      name: "LesteManagerDetails",
      params: {
        customerId: customerItem.id,
      },
    });
  }

}
